import React from "react";
import FundingWrap from "./FundingWrap";

function Funding(props) {
    return (
        <>
            <FundingWrap/>
        </>
    )
}

export default Funding;
